module.exports = __webpack_public_path__ + "img/Blumenthal.a90cf5ce.png";